import React from 'react';
import { fiMigrationUtils } from 'app-components/flux/account-discovery';
import { useFiMigrationPrompt } from 'app-components/hooks/accounts/useFiMigration';
import ConnectionUpdateBanner from './ConnectionUpdateBanner';
import useConnectionUpdate from './useConnectionUpdate';

export default function AccountConnectionUpdateBanner({
  institutionLoginId,
  location,
}: {
  institutionLoginId: string;
  location: 'account settings' | 'transactions';
}): React.JSX.Element | null {
  const surface = location === 'account settings' ? 'settings banner' : 'single account notification';
  const { institutionLogin, onUpdate } = useConnectionUpdate(institutionLoginId, {
    entry: surface,
    location: location === 'account settings' ? 'account settings' : 'account list',
  });
  const trackPrompt = useFiMigrationPrompt({ institutionLogin, surface, location });
  if (!institutionLogin) return null;

  return (
    <ConnectionUpdateBanner
      title={
        location === 'account settings'
          ? `A new connection is ready for ${institutionLogin.name}`
          : 'A new connection is available for this account'
      }
      description='Update now for more reliable syncing and fewer issues - it only takes a minute.'
      onUpdate={() => {
        trackPrompt('clicked');
        onUpdate();
      }}
      learnMoreUrl={fiMigrationUtils.FI_MIGRATION_LEARN_MORE_URL}
      onLearnMore={() => trackPrompt('learn_more')}
    />
  );
}
